import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

// Beneficiaries of the pooled donate-once program (active medical campaigns),
// returned in queue order: { id, beneficiary_name, campaign_title, goal, raised, priority, is_fully_funded }
export const getBeneficiaries = async () => {
  try {
    return await axiosInstance.get(API_ENDPOINTS.GET_BENEFICIARIES);
  } catch (error) {
    throw error;
  }
};

export default {
  getBeneficiaries,
};
